import {toggleNotificationCenter} from 'openfin-notifications';

import {Action, StoreAPI} from '../Store';
import {RootState} from '../State';

export class ToggleNotificationCenter extends Action<RootState> {
    public readonly type: string = '@@NOTIFICATIONS/TOGGLE_CENTER';

    public async call(store: StoreAPI<RootState>, complete: () => Promise<void>): Promise<void> {
        await toggleNotificationCenter();
    }
}
